import React from "react";
import { useTranslation } from "react-i18next";
import "./DemoPreviewCard.css";

interface DemoPreviewCardProps {
  onClick: () => void;
  isLocalhost: boolean;
}

const STORYLANE_PREVIEW_URL = "https://app.storylane.io/share/pakottugzdnb";

const DemoPreviewCard: React.FC<DemoPreviewCardProps> = ({
  onClick,
  isLocalhost,
}) => {
  const { t } = useTranslation("marketing");

  const handleKeyDown = (e: React.KeyboardEvent) => {
    if (e.key === "Enter" || e.key === " ") {
      e.preventDefault();
      onClick();
    }
  };

  return (
    <div
      className="demo-preview-card"
      onClick={onClick}
      onKeyDown={handleKeyDown}
      role="button"
      tabIndex={0}
      aria-label={t("landing.demoPreview.ariaLabel")}
    >
      {isLocalhost ? (
        <div className="demo-preview-card__placeholder">
          <span className="demo-preview-card__placeholder-text">
            {t("landing.demoPreview.localhostPlaceholder")}
          </span>
        </div>
      ) : (
        <>
          {/* Background iframe preview — non-interactive */}
          <div className="demo-preview-card__iframe-wrapper" aria-hidden="true">
            <iframe
              src={STORYLANE_PREVIEW_URL}
              className="demo-preview-card__iframe"
              title=""
              tabIndex={-1}
              loading="lazy"
            />
          </div>

          {/* Play overlay */}
          <div className="demo-preview-card__overlay">
            <div className="demo-preview-card__play-icon">
              <svg
                width="56"
                height="56"
                viewBox="0 0 56 56"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <circle cx="28" cy="28" r="28" fill="rgba(0,0,0,0.45)" />
                <path d="M22 17L40 28L22 39V17Z" fill="white" />
              </svg>
            </div>
            <span className="demo-preview-card__label">
              {t("landing.demoPreview.clickToExplore")}
            </span>
          </div>
        </>
      )}
    </div>
  );
};

export default DemoPreviewCard;
